import { Component, ViewChild } from '@angular/core';
import { HeaderService } from '@app/core/services/header.service';
import { ODataService } from '@app/core/services/odata/odata.service';
import { SortParam } from '@app/core/constants/sort-param';
import { Observable } from 'rxjs';
import { ODataType } from '@app/core/services/odata/types/odata-type';
import { TableComponent } from '@shared/components/table/table.component';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { dashboardColumns } from '@shared/columns/dashboard.columns';
import { odataTableConfig } from '@app/core/config/odata-table-config';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';

@Component({
  selector: 'app-dashboard-metered-data-not-created',
  imports: [
    TableComponent
  ],
  templateUrl: './dashboard-metered-data-not-created.component.html',
  styleUrl: './dashboard-metered-data-not-created.component.css',
})
export class DashboardMeteredDataNotCreatedComponent {
  @ViewChild('table', { static: false }) public table?: TableComponent<any>;

  public tableConfig: TableConfig<any> = {
    id: 'table-dashboard-metered-data-not-created',
    title: 'dashboard.query.metereddatanotcreated.title',
    columns: [
      {
        title: 'dashboard.timeseries.missing.dateofwork',
        key: 'occurrence',
        cellRenderer: DateCellComponent
      },
      ...dashboardColumns,
    ],
    activeColumns: ['meteringPointIdentification', 'occurrence', 'createdTs'],
    ...odataTableConfig,
    selectable: false,
    fetchOnLoad: true,
    serviceCallback: (pageSize: number, page: number, order?: SortParam) => this.search(pageSize, page, order),
  }

  constructor(
    private readonly headerService: HeaderService,
    private readonly oDataService: ODataService,
  ) {
    this.headerService.setTitle('dashboard.query.metereddatanotcreated.title');
  }

  public search(pageSize: number, page: number, sort?: SortParam): Observable<any> {
    return this.oDataService.dmc.getPaginated(ODataType.meteredDataNotCreated, { pageSize, page, sort });
  }

}
